import React from "react";
import { IconProps } from "./IconProps";

const WarningIcon: React.FC<IconProps> = ({
  size,
  thickness,
  ariaLabel,
  color = "currentColor",
}) => {
  switch (`${size}${thickness}`) {
    case "32Light":
      return (
        <svg
          aria-label={ariaLabel}
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M29.3838 23.6362L18.4513 4.65249C18.2002 4.22555 17.8419 3.87159 17.412 3.62566C16.982 3.37973 16.4953 3.25037 16 3.25037C15.5047 3.25037 15.018 3.37973 14.588 3.62566C14.1581 3.87159 13.7998 4.22555 13.5487 4.65249L2.61625 23.6362C2.37561 24.0482 2.24879 24.5167 2.24879 24.9937C2.24879 25.4708 2.37561 25.9393 2.61625 26.3512C2.86399 26.7812 3.22177 27.1374 3.65281 27.3832C4.08384 27.6291 4.57257 27.7556 5.06875 27.75H26.9312C27.427 27.7552 27.9152 27.6284 28.3458 27.3826C28.7763 27.1368 29.1337 26.7808 29.3813 26.3512C29.6223 25.9395 29.7495 25.4711 29.75 24.9941C29.7504 24.517 29.624 24.0484 29.3838 23.6362ZM28.0825 25.6C27.9657 25.8009 27.7974 25.967 27.5951 26.0812C27.3927 26.1955 27.1636 26.2537 26.9312 26.25H5.06875C4.83641 26.2537 4.60727 26.1955 4.40492 26.0812C4.20257 25.967 4.03432 25.8009 3.9175 25.6C3.80822 25.4162 3.75055 25.2063 3.75055 24.9925C3.75055 24.7787 3.80822 24.5688 3.9175 24.385L14.8488 5.40124C14.9683 5.20272 15.1371 5.03847 15.3388 4.92446C15.5405 4.81044 15.7683 4.75052 16 4.75052C16.2317 4.75052 16.4595 4.81044 16.6612 4.92446C16.8629 5.03847 17.0317 5.20272 17.1513 5.40124L28.0837 24.385C28.1928 24.5689 28.2503 24.7788 28.2501 24.9927C28.2499 25.2065 28.192 25.4163 28.0825 25.6ZM15.25 18V13C15.25 12.8011 15.329 12.6103 15.4697 12.4697C15.6103 12.329 15.8011 12.25 16 12.25C16.1989 12.25 16.3897 12.329 16.5303 12.4697C16.671 12.6103 16.75 12.8011 16.75 13V18C16.75 18.1989 16.671 18.3897 16.5303 18.5303C16.3897 18.671 16.1989 18.75 16 18.75C15.8011 18.75 15.6103 18.671 15.4697 18.5303C15.329 18.3897 15.25 18.1989 15.25 18ZM17.25 22.5C17.25 22.7472 17.1767 22.9889 17.0393 23.1945C16.902 23.4 16.7068 23.5602 16.4784 23.6548C16.2499 23.7494 15.9986 23.7742 15.7561 23.726C15.5137 23.6777 15.2909 23.5587 15.1161 23.3839C14.9413 23.2091 14.8222 22.9863 14.774 22.7439C14.7258 22.5014 14.7505 22.25 14.8452 22.0216C14.9398 21.7932 15.1 21.598 15.3055 21.4607C15.5111 21.3233 15.7528 21.25 16 21.25C16.3315 21.25 16.6495 21.3817 16.8839 21.6161C17.1183 21.8505 17.25 22.1685 17.25 22.5Z"
            fill={color}
          />
        </svg>
      );
    default:
      return null;
  }
};

export default WarningIcon;
